import type { SourcingOpenings } from 'api-clients/monolith';
import type { IneligibleOpeningReason } from '@/components/pages/job-posting/types';

export type ListingStatus = NonNullable<SourcingOpenings['listing_status']>;

export function getPostingIneligibilityReason(
  opening: {
    active?: boolean;
    isSourcingEnabled?: boolean;
    listingStatus?: ListingStatus;
  },
  listingStatusActive: boolean,
): IneligibleOpeningReason | null {
  if (opening.active === false) return 'inactive';
  if (listingStatusActive) {
    if (opening.listingStatus === 'public') return null;
    return opening.listingStatus ?? 'not_posted';
  }
  return opening.isSourcingEnabled === false ? 'sourcing_disabled' : null;
}
